import { ApplicationConfig, DEFAULT_CURRENCY_CODE, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { includeBearerTokenInterceptor } from 'keycloak-angular';

import { provideKeycloakAngular } from './configs/keycloak.config';

import { NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { routes } from './app.routes';
import { errorInterceptor } from './utilities/interceptors/error.interceptor';
import { Iso8601AdapterService } from './utilities/services/datepicker/iso8601-adapter.service';
import { DateParserFormatterService } from './utilities/services/datepicker/date-parser-formatter.service';


export const appConfig: ApplicationConfig = {
  providers: [
    provideKeycloakAngular(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    { provide: LOCALE_ID, useValue: 'it' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
    provideHttpClient(withInterceptors([includeBearerTokenInterceptor, errorInterceptor])),
    { provide: NgbDateAdapter, useClass: Iso8601AdapterService },
		{ provide: NgbDateParserFormatter, useClass: DateParserFormatterService }
  ]
};
